var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"LeasedCarsPercentage"}},[_c('h2',[_vm._v("品牌占比率")]),_c('echarts-com',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"id":"LeasedCarsChart","options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }